<template>
  <b-modal
    no-close-on-backdrop
    size="md"
    hide-footer
    id="view_group"
    modal-class="modern-modal"
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <template v-slot:modal-title>
      <div class="modal-title-modern">
        <i class="fas fa-edit mr-2"></i>
        Editar Grupo
      </div>
    </template>

    <div class="modal-content-modern">
      <form @submit.prevent="evOnSubmit">
        <div class="form-section">
          <div class="form-group">
            <label-required-field label="Nome do Grupo" />
            <input
              type="text"
              ref="autofocus"
              v-model="name"
              class="modern-form-input"
              placeholder="Digite o nome do grupo"
            />
            <small class="form-help">
              <i class="fas fa-info-circle mr-1"></i>
              Altere o nome do local de armazenamento
            </small>
          </div>
        </div>

        <!-- Current Info Section -->
        <div class="current-info-section" v-if="group">
          <h4 class="info-title">
            <i class="fas fa-warehouse mr-2"></i>
            Informações Atuais
          </h4>
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">Nome Atual:</span>
              <span class="info-value">{{ group.name }}</span>
            </div>
            <div class="info-item" v-if="group.main_stock">
              <span class="info-label">Tipo:</span>
              <span class="info-value main-stock">
                <i class="fas fa-star mr-1"></i>
                Estoque Principal
              </span>
            </div>
          </div>
        </div>

        <!-- Warning Section -->
        <div class="warning-section">
          <div class="warning-content">
            <i class="fas fa-exclamation-triangle warning-icon"></i>
            <div class="warning-text">
              <strong>Atenção:</strong>
              <span
                >Esta alteração afetará todos os itens associados a este
                grupo.</span
              >
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="form-footer">
          <warning-required-fields />
          <errors-messages :errors="errors" />

          <div class="form-actions">
            <v-btn :disabled="loading" type="submit" class="btn-save-modern">
              <i class="fas fa-save mr-2"></i>
              {{ loading ? "Salvando..." : "Salvar Alterações" }}
            </v-btn>
          </div>
        </div>
      </form>
    </div>
  </b-modal>
</template>

<script>
import WarningRequiredFields from "../../Components/WarningRequiredFields";
import ErrorsMessages from "../../Components/ErrorsMessages";
import LabelRequiredField from "../../Components/LabelRequiredField";
import api from "../../../services/api";
import toast from "../../../lib/ToastNotification";

export default {
  name: "ViewGroup",

  components: {
    WarningRequiredFields,
    ErrorsMessages,
    LabelRequiredField,
  },

  props: {
    group: [Object, null],
  },

  data() {
    return {
      errors: [],
      loading: false,
      name: "",
    };
  },

  watch: {
    group() {
      if (this.group) this.$bvModal.show("view_group");
    },
  },

  methods: {
    async evOnShow() {
      this.errors = [];
      this.loading = false;
      this.name = this.group.name;
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {
      this.$emit("close");
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        const data = {
          id: this.group.id,
          name: this.name,
        };
        const response = await api.patch("/rest-home/stock/group", data);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$bvModal.hide("view_group");
          this.$emit("updated");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* Modal Title */
.modal-title-modern {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.modal-title-modern i {
  color: #0f65b0;
}

/* Modal Content */
.modal-content-modern {
  padding: 8px 0;
}

.form-section {
  margin-bottom: 24px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.modern-form-input {
  border: 2px solid #e5e7eb !important;
  border-radius: 8px !important;
  padding: 12px 16px !important;
  font-size: 14px !important;
  transition: all 0.3s ease !important;
  background: white !important;
}

.modern-form-input:focus {
  border-color: #0f65b0 !important;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1) !important;
  outline: none !important;
}

.form-help {
  color: #6b7280;
  font-size: 12px;
  margin-top: 4px;
  display: flex;
  align-items: center;
}

.form-help i {
  color: #9ca3af;
}

/* Current Info Section */
.current-info-section {
  background: #f8fafc;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e5e7eb;
  margin-bottom: 24px;
}

.info-title {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
}

.info-title i {
  color: #0f65b0;
}

.info-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: white;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}

.info-label {
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
}

.info-value {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
}

.info-value.main-stock {
  color: #d97706;
  display: flex;
  align-items: center;
}

.info-value.main-stock i {
  color: #f59e0b;
}

/* Warning Section */
.warning-section {
  background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
  border: 1px solid #f59e0b;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;
}

.warning-content {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.warning-icon {
  color: #d97706;
  font-size: 18px;
  margin-top: 2px;
  flex-shrink: 0;
}

.warning-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.warning-text strong {
  color: #92400e;
  font-size: 14px;
  font-weight: 600;
}

.warning-text span {
  color: #92400e;
  font-size: 13px;
  line-height: 1.4;
}

/* Form Footer */
.form-footer {
  border-top: 1px solid #e5e7eb;
  padding-top: 20px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.btn-save-modern {
  background: linear-gradient(135deg, #1e884d 0%, #16a34a 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(30, 136, 77, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-save-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(30, 136, 77, 0.4) !important;
}

.btn-save-modern:disabled {
  opacity: 0.7 !important;
  cursor: not-allowed !important;
  transform: none !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .current-info-section {
    padding: 16px;
  }

  .info-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .modal-content-modern {
    padding: 0;
  }
}

@media (max-width: 480px) {
  .modal-title-modern {
    font-size: 18px;
  }

  .warning-content {
    flex-direction: column;
    gap: 8px;
  }

  .warning-icon {
    align-self: flex-start;
  }
}
</style>

<!-- Global Modal Styles -->
<style>
.modern-modal >>> .modal-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
  border-bottom: 1px solid #e5e7eb !important;
  border-radius: 0 !important;
}

.modern-modal >>> .modal-body {
  padding: 24px !important;
}

.modern-modal >>> .modal-content {
  border: none !important;
  border-radius: 16px !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
}
</style>